// extracted by mini-css-extract-plugin
export default {"crossContainer":"EmptyPlayerCross_crossContainer__gg-B8","crossLine1":"EmptyPlayerCross_crossLine1__zoX7v","crossLine2":"EmptyPlayerCross_crossLine2__W5akt"};